import * as React from "react";
const SvgFiRrStrikethrough = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-strikethrough_svg__a)">
      <path
        fill="#062147"
        d="M24 12a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h4.081A5.86 5.86 0 0 1 2 5.849 5.856 5.856 0 0 1 7.848 0h8.235A5.924 5.924 0 0 1 22 5.917V7a1 1 0 1 1-2 0V5.917A3.92 3.92 0 0 0 16.083 2H7.848A3.853 3.853 0 0 0 4 5.849a3.856 3.856 0 0 0 2.84 3.714l5.293 1.438H23a1 1 0 0 1 1 1zm-3.943 3.11a1 1 0 0 0-.454 1.34A3.853 3.853 0 0 1 16.151 22H7.917A3.92 3.92 0 0 1 4 18.083V17a1 1 0 1 0-2 0v1.083A5.923 5.923 0 0 0 7.917 24h8.235A5.855 5.855 0 0 0 22 18.151a5.86 5.86 0 0 0-.604-2.588 1 1 0 0 0-1.339-.453"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-strikethrough_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStrikethrough;
